import React, { forwardRef } from 'react';
import cn from 'classnames';
import SvgIcon from '../../../common/SvgIcon';
import Tooltip from '../../../common/components/Tooltip';
import { SERVICES } from '../../../common/constants/brief';

const GettingStartedServices = (
  { value, invalid, proPlatform, className, onChange, children, ...rest },
  ref,
) => (
  <div {...rest} ref={ref} className={cn('tab', className)}>
    <div className="tab_question">{`Question 3 of ${proPlatform ? '5' : '7'}`}</div>
    <div className="tab_tag">
      <SvgIcon icon="icon-question-step-4" />
    </div>
    <div className="tab_title">
      <div className={cn('-bold', { 'has-error -error-position-right': invalid })}>
        Are there any other services you will need or are using?
        {invalid && <div className="form-error">please, select your service(s)</div>}
      </div>
      <div className="tile-selection_bottom-description">(select all that apply)</div>
    </div>
    <div className="getting-started_tags">
      {SERVICES.map(service => (
        <div
          key={service.title}
          role="getting-started_tag"
          className={cn('getting-started_tag', { '-active': value.includes(service.title) })}
          onClick={() => onChange(service.title)}
        >
          <span className={cn({ 'getting-started_tag-text': !!service.tooltip })}>
            {service.title}
          </span>

          {service.tooltip && (
            <Tooltip
              className="getting-started_tag-tooltip"
              tooltip={service.tooltip}
              data-tooltip-left={1}
            >
              i
            </Tooltip>
          )}
        </div>
      ))}
    </div>
    {children}
  </div>
);

export default forwardRef(GettingStartedServices);



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedServices.js